import { PRODUCT_ECOMMERCE_STATUS } from '@enums';

export const filterNonDemoProducts = (products) => {
    return products.filter((product) => product.ecommerceStatus !== PRODUCT_ECOMMERCE_STATUS.DEMO);
};

export const hasNonDemoProducts = (products, meta) => {
    const filteredProducts = filterNonDemoProducts(products);
    return meta?.total ? meta.total > 0 : !!filteredProducts.length;
};
